import {
  GET_BOOKING,
  GET_BOOKING_FAILED,
  GET_BOOKING_LOADING,
  GET_BOOKING_REQUIRED_DATA,
  GET_BOOKING_REQUIRED_DATA_SUCCESS,
  GET_BOOKING_SUCCESS,
  GET_TICKET_CUSTOMER_DATA_CHANGES,
  GET_TICKET_CUSTOMER_DATA_CHANGES_SUCCESS,
  UPDATE_BOOKING_DELIVERIES,
  UPDATE_BOOKING_DELIVERY,
  UPDATE_BOOKING_RESALE,
  UPDATE_BOOKING_RESALE_FAILED,
  UPDATE_BOOKING_RESALE_SUCCESS,
} from './types';

export const getBooking = reference => ({
  type: GET_BOOKING,
  payload: {
    booking_ref: reference,
  },
});

export const getBookingLoading = (reference, isLoading) => ({
  type: GET_BOOKING_LOADING,
  payload: {
    booking_ref: reference,
    isLoading,
  },
});

export const getBookingSuccess = booking => ({
  type: GET_BOOKING_SUCCESS,
  payload: { booking },
});

export const getBookingFailure = booking_ref => ({
  type: GET_BOOKING_FAILED,
  payload: { booking_ref },
});

export const updateBookingDelivery = (booking_ref, allocation_id, fields) => ({
  type: UPDATE_BOOKING_DELIVERY,
  payload: {
    booking_ref,
    allocation_id,
    fields,
  },
});

export const updateBookingDeliveries = (
  currentBooking,
  bookingRefs,
  fields,
) => ({
  type: UPDATE_BOOKING_DELIVERIES,
  payload: {
    currentBooking,
    bookingRefs,
    fields,
  },
});

export const updateBookingResale = (booking_ref, tickets) => ({
  type: UPDATE_BOOKING_RESALE,
  payload: {
    booking_ref,
    tickets,
  },
});

export const updateBookingResaleSuccess = () => ({
  type: UPDATE_BOOKING_RESALE_SUCCESS,
});

export const updateBookingResaleFailed = () => ({
  type: UPDATE_BOOKING_RESALE_FAILED,
});

export const getBookingRequiredData = booking_ref => ({
  type: GET_BOOKING_REQUIRED_DATA,
  payload: {
    booking_ref,
  },
});

export const getBookingRequiredDataSuccess = (booking_ref, required_data) => ({
  type: GET_BOOKING_REQUIRED_DATA_SUCCESS,
  payload: {
    booking_ref,
    required_data,
  },
});

export const getTicketCustomerDataChanges = bookingRef => ({
  type: GET_TICKET_CUSTOMER_DATA_CHANGES,
  payload: {
    bookingRef,
  },
});

export const getTicketCustomerDataChangesSuccess = (
  ticketCustomerDataChanges,
  bookingRef,
) => ({
  type: GET_TICKET_CUSTOMER_DATA_CHANGES_SUCCESS,
  payload: {
    bookingRef,
    ticketCustomerDataChanges,
  },
});
